export default __webpack_public_path__ + "static/media/74.2a2ff98a.jpg";